"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class InterleaveBuffer {
  constructor(iterator, bufferIndex) {
    this._iterator = iterator;
    this._next = iterator.next();
    this.bufferIndex = bufferIndex;
    this.index = 0;
  }

  peek() {
    return this._next.value;
  }

  take() {
    const next = this._next;

    if (!next.done) {
      this._next = this._iterator.next();
      this.index++;
    }

    return next.value;
  }

  canTake() {
    return !this._next.done;
  }

}

var _default = InterleaveBuffer;
exports.default = _default;
module.exports = exports["default"];